/* eslint-disable max-len */
const orders = '/v0/orders';
const tours = '/v0/orders/tour';
const companiesApi = '/v0/companies';
const companiesApiV1 = '/v1/companies';
const statisticsApi = '/v0/stats';
const personalizationApi = '/v0/personalizations';
const monitoringOrdersApi = '/v0/monitoring-orders';
const sharedVehiclesApi = '/v0/shared-vehicles';
const vehiclesApi = '/v0/vehicles';
const vehicleApi = '/v0/vehicle';
const invitationApi = '/v0/companies/company';
const requests = 'v1/monitoring-requests';
const locationSuggesterSearchApi = '/v0/location-suggestions/search';
const locationDetailsApi = '/v0/location-suggestions';
const selfServiceTelematicAccountsApi = '/v0/self-service/telematic-accounts';
const providerAccountsApi = '/v0/provider-accounts';
const inboundTelematicConnectionCreationAttemptsApi = '/v0/inbound-telematic-connection-creation-attempts';
const companyApi = '/v0/company';

const paramIfExists = (name, val) => (val ? `${name}=${val}` : '');
export default {
  personsMe: () => '/v0/persons/me',

  locationSuggesterSearchApi: () => locationSuggesterSearchApi,
  locationDetailsApi: (locationId) => `${locationDetailsApi}/${locationId}`,
  companies: () => companiesApi,
  companiesSearch: () => `${companiesApi}/search`,
  findCompany: () => '/v0/companies/find',
  vehiclesSearch: (companyId) => `${companiesApi}/${companyId}/vehicles/search`,
  companyVehicleRelationExists: () => `${companiesApi}/vehicles/relationExists`,
  vehicleDetails: (companyId, vehicleId, providingCompanyId) => `${companiesApi}/${companyId}/vehicles/${vehicleId}?${paramIfExists('providingCompanyId', providingCompanyId)}`,
  vehicleRemark: (companyId, vehicleId) => `${companiesApi}/${companyId}/vehicles/${vehicleId}/remarks`,
  vehicleDrivingTime: (companyId, vehicleId) => `${companiesApi}/${companyId}/vehicles/${vehicleId}/drivingTime`,
  vehiclesWithDriveTime: (companyId) => `${companiesApi}/${companyId}/vehicles/drivingTime/availability`,
  sharingsSearch: (companyId) => `${companiesApi}/${companyId}/sharings/search`,
  allCompanies: () => `${companiesApiV1}`,
  companyVehicles: (companyId) => `${companiesApiV1}/${companyId}/vehicles`,
  companyVehiclesForPermanentMonitoring: (companyId) => `${companiesApiV1}/${companyId}/vehicles/permanent-monitoring`,

  carriersInvitationSearch: (companyId) => `${invitationApi}/${companyId}/carriers/search`,
  companyPredefinedLocationConsents: (companyId) => `${companiesApi}/${companyId}/predefined-location-consents`,
  companyPredefinedLocationConsentRevoke: (companyId, consentId) => `${companiesApi}/${companyId}/predefined-location-consents/${consentId}/revoke`,

  creatMonitoringRequest: () => `${requests}/create`,
  requestsOutgoingSearch: (companyId, userId) => `${requests}/outgoing/company/${companyId}/user/${userId}`,
  requestsIncomingSearch: (companyId, userId) => `${requests}/incoming/company/${companyId}/user/${userId}`,

  requestsMonitoringDecline: () => `${requests}/decline`,
  requestsMonitoringAccept: () => `${requests}/accept`,
  requestsMonitoringDeactivate: () => `${requests}/deactivate`,

  requestsDetails: (requestId, companyId) => `${requests}/${requestId}/company/${companyId}`,

  vehicle: () => vehicleApi,
  editVehicles: () => `${vehiclesApi}/edit`,

  generateReport: () => '/v0/documents/generate',
  generateMonitoringReport: () => '/v0/documents/generate/monitoring',
  generateMonitoringEtaReport: () => '/v0/documents/generate/monitoring/eta',
  generateMonitoringEtaCustomerReport: () => '/v0/documents/generate/monitoring/eta-customer',
  generateMonitoringOrdersCo2EmissionReport: () => '/v0/monitoring-orders/co2-emission-report',

  shareVehicle: () => sharedVehiclesApi,
  stopSharingVehicle: () => `${sharedVehiclesApi}/stop`,
  editSharingVehicle: () => `${sharedVehiclesApi}/edit`,

  orders: () => tours,
  csvImportAnalyzeFile: () => `${tours}/csv/analyze-file`,
  csvImportAnalyze: () => `${tours}/csv/analyze`,
  csvImportImport: () => `${tours}/csv/import`,
  aiImportAnalyzeFile: () => `${tours}/ai/analyze-file`,
  aiImportAnalyze: () => `${tours}/ai/analyze`,
  aiImportPreview: (previewId) => `${tours}/ai/preview/${previewId}`,
  aiImportImport: () => `${tours}/ai/import`,
  updateOrder: (internalId) => `${tours}/${internalId}`,
  emailSharingsSearch: () => `${orders}/sharings`,
  emailSharingsDelete: (orderId) => `${orders}/${orderId}/sharings`,
  ordersByTypeSearch: (orderType) => `${tours}/${orderType}/search`,
  orderDetails: (internalId) => `${tours}/${internalId}/details`,
  orderDeactivation: (internalId) => `${tours}/${internalId}/deactivation`,
  orderShareToEmail: (orderId) => `${orders}/${orderId}/sharings`,
  orderPositions: (internalId) => `${tours}/${internalId}/positions`,
  calculateEta: (id) => `${orders}/${id}/eta`,
  geofencing: (id) => `${orders}/${id}/geofencing`,
  orderCarriers: () => `${monitoringOrdersApi}/carriers`,
  snapshot: (monitoringOrderId) => `${monitoringOrdersApi}/${monitoringOrderId}/snapshot`,

  tableConfigurations: (table) => `${personalizationApi}/tables/${table}/configurations`,
  tableConfiguration: (table, configurationId) => `${personalizationApi}/tables/${table}/configurations/${configurationId}`,
  lastUsedConfiguration: (table) => `${personalizationApi}/tables/${table}/configurations/latest`,
  lastUsedInterfaceConfiguration: (table) => `${personalizationApi}/tables/${table}/interfaces/latest`,
  featureToggles: () => `${personalizationApi}/current/features`,

  vehicleLastTrace: (vehicleId) => `${statisticsApi}/vehicles/${vehicleId}/positions/latest`,
  vehiclePositionStatistics: (vehicleId) => `${statisticsApi}/vehicles/${vehicleId}/positions`,

  providerAccountBase: () => `${providerAccountsApi}`,
  providerAccountsOverview: () => `${providerAccountsApi}/overview`,
  providerAccountById: (accountId) => `${providerAccountsApi}/${accountId}`,
  providerAccountDetails: (accountId) => `${providerAccountsApi}/${accountId}/details`,
  providerAccountNewDevices: (accountId) => `${providerAccountsApi}/${accountId}/new-devices`,
  providerAccountConnectedDevices: (accountId) => `${providerAccountsApi}/${accountId}/connected-devices`,
  providerAccountDeactivatedDevices: (accountId) => `${providerAccountsApi}/${accountId}/deactivated-devices`,
  providerAccountActivateDevices: (accountId) => `${providerAccountsApi}/${accountId}/devices/activate`,
  providerAccountAuthMethods: (accountId) => `${providerAccountsApi}/${accountId}/auth/methods`,
  providerAccountAuthCode: (accountId) => `${providerAccountsApi}/${accountId}/auth/code`,
  providerAccountAuthToken: (accountId) => `${providerAccountsApi}/${accountId}/auth/token`,
  telematicAccountFormConfig: () => `${selfServiceTelematicAccountsApi}/form-config`,
  inboundTelematicConnectionCreationAttempt: () => inboundTelematicConnectionCreationAttemptsApi,
  inboundTelematicLastCreationAttempt: () => `${inboundTelematicConnectionCreationAttemptsApi}/last`,
  telematicAccountUnknownProvider: () => `${selfServiceTelematicAccountsApi}/unknown-provider`,
  telematicAccountSupportRequired: () => `${selfServiceTelematicAccountsApi}/support-required`,
  predefinedLocationAssets: (companyId) => `${companyApi}/${companyId}/predefined-location/assets`,
  predefinedLocationExists: (companyId) => `${companyApi}/${companyId}/predefined-location/exists`,
  predefinedLocations: (companyId) => `${companyApi}/${companyId}/predefined-location`,
  predefinedLocationAssetsSummary: (companyId) => `${companyApi}/${companyId}/predefined-location/assets/summary`,
  companyGivenConsents: (companyId) => `${companyApi}/${companyId}/consents/given`,
};
